import React from 'react';
import { Paper, LinearProgress } from '@mui/material';
import Loaders from '../..';

export function Loading() {
  return (
    <Paper style={{ padding: 16 }}>
      <LinearProgress />
      <LinearProgress />
    </Paper>
  );
}

export const getListCardItemByType = (type, DefaultComponent) => {
  if (Loaders[type] && Loaders[type].views.listCardItem) {
    return Loaders[type].views.listCardItem();
  }
  return DefaultComponent || Loaders.Thing.views.listCardItem();
};

const loadView = (type, DefaultComponent) => getListCardItemByType(type, DefaultComponent);
export default loadView;
